import React from 'react'
import '../../App.css'

export default function Contact() {
  return (
    <div className="contact">
      <div className="contact_card">
          <a href="mailto:ed@djmelech.com" class="custom-link">INFO@DJMELECH.COM</a><br/><br/>
          <a href="https://www.instagram.com/dj_melech/" target="_blank" rel="noreferrer" class="custom-link">INSTAGRAM</a><br/>
          <a href="https://www.facebook.com/DJMelech" target="_blank" rel="noreferrer" class="custom-link">FACEBOOK</a><br/>
          <a href="https://twitter.com/EdMelech" target="_blank" rel="noreferrer" class="custom-link">TWITTER</a><br/>
          <a href="https://ra.co/dj/melech" target="_blank" rel="noreferrer" class="custom-link">RESIDENT ADVISOR</a><br/>
          <a href="https://soundcloud.com/djmelech" target="_blank" rel="noreferrer" class="custom-link">SOUNDCLOUD</a><br/>
      </div>
    </div>
  );
}